module.exports = __webpack_public_path__ + "static/media/s_v8_t2.59a8cf71.mp3";